<template>
	<section class="page">
		<el-tabs v-model="activeName">
			<el-tab-pane label="轮播图" name="list">
				<div class="content-box" v-if="activeName=='list'">
					<div class="operator">
						<div class="operator-col">
							<el-button size="mini" type="primary" @click="handleCreate()" v-loading="loadings.create">新建</el-button>
						</div>
					</div>
					<curd-table
						ref="listTable"
						:data-model="editorDataModel"
						:fields="tableFields"
						@doedit="handleEdit($event)"
					></curd-table>
				</div>
			</el-tab-pane>
		</el-tabs>
		<editor
			:show.sync="editorVisible"
			:data-model-name="editorDataModel"
			:record-id="editorId"
			:fields="editorFields"
			@change="refreshTable('listTable')"
		></editor>
	</section>
</template>

<script>
import Editor from "@/components/Editor.vue";
import CurdTable from "@/components/CurdTable.vue";
import CurdPage from "@/mixins/CurdPage.js";

export default {
	mixins: [CurdPage],
	data() {
		return {
			loadings: {
				main: false
			},
			activeName: "list",
			editorVisible: false,
			editorDataModel: "Carousel",
			editorId: "",

			tableFields: [

				{
					name: "pos",
					isTrans: true,
					sortable: "custom"
				},
				{
					name: "key",
					isTrans: true,
					sortable: "custom"
				},
				{
					name: "pic",
					isTrans: true,
					sortable: false
				},
				{
					name: "link_type",
					isTrans: true,
					sortable: false
				},

			],
			editorFields: [
	
				{
					name: "pic",
					isTrans: true,
					rules: ["required"],
					col: 6
				},
				{
					name: "pos",
					isTrans: true,
					col: 6
				},
				{
					name: "link_type",
					isTrans: true,
					col: 6
				},
				{
					name: "key",
					col: 6
				},

			]
		};
	},
	computed: {},
	created() {},
	mounted() {},
	methods: {},
	watch: {},
	components: {
		Editor,
		CurdTable
	}
};
</script>
<style lang="scss" scoped>
</style>
